var icon = require('vue-svgicon')
icon.register({
  'ks-icon-officer': {
    width: 128,
    height: 128,
    viewBox: '0 0 128 128',
    data: '<path pid="0" d="M45.75 48.69a17.4 17.4 0 0 0-.24 2.82 18.17 18.17 0 0 0 36.33 0 17.39 17.39 0 0 0-.25-2.82 89.69 89.69 0 0 1-17.92 1.75 89.69 89.69 0 0 1-17.92-1.75zM63.67 78.75c-20.07 0-36.33 8.13-36.33 18.17V106H100v-9.08c0-10.04-16.26-18.17-36.33-18.17zM83.5 38l1.77-7.43a1 1 0 0 0-.7-1.12s-8.32-1.45-12.2-2.99a46.06 46.06 0 0 1-8.22-4.38 1.51 1.51 0 0 0-.48-.08 1.56 1.56 0 0 0-.48.08A46.06 46.06 0 0 1 55 26.46c-3.91 1.54-12.22 2.95-12.22 2.95a1 1 0 0 0-.71 1.12L43.84 38a.93.93 0 0 0 .42.58c.49.34 1.44 1 2.3 1.58a34.76 34.76 0 0 0-3.39 4.28 1 1 0 0 0 .71 1.43 77 77 0 0 0 19.79 2.5 77 77 0 0 0 19.79-2.5 1 1 0 0 0 .71-1.43 34.76 34.76 0 0 0-3.38-4.28l2.29-1.58a.9.9 0 0 0 .42-.58z"/>'
  }
})
